import React, { useMemo } from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import MenuItem from "@mui/material/MenuItem";
import _ from "lodash";

function BorderWidth({ name, required }: JSInputProps) {
  const sizes = useMemo(() => {
    return [..._.times(32)];
  }, []);
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"default"} value={"default"}>
          Default
        </MenuItem>,
        sizes.map((lh) => {
          return (
            <MenuItem key={lh} value={`${lh}px`}>
              {lh} px
            </MenuItem>
          );
        }),
      ]}
      rules={{ required }}
    />
  );
}

export const JSBorderWidthComponent: JSInputComponent = {
  Component: BorderWidth,
  handlesCssProperties: ["borderWidth"],
};
